module.exports = "\r\n.row:nth-child(odd){\r\n  background: #ececec;\r\n  padding-top: 10px;\r\n} \r\n.row:nth-child(even){     \r\n  padding-top: 10px;\r\n} \r\n.error-msg{\r\n    color:red;\r\n    font-size:12px;\r\n    margin-top:-2px;\r\n    display: block;\r\n  }\r\n\r\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/sainik-registration/dependents/dependents.component.css
// module id = ./src/app/sainik-registration/dependents/dependents.component.css
// module chunks = main